import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001'

const useExperiencePreview = (experienceId, enabled = true) => {
	const [searchParams, setSearchParams] = useSearchParams()
	const [data, setData] = useState()
	const stationId = searchParams.get('stationId') || ''
	const segmentId = searchParams.get('segmentId') || ''

	useEffect(() => {
		if (!enabled || !experienceId) return undefined

		const controller = new AbortController()
		const query = new URLSearchParams()
		if (stationId) query.set('stationId', stationId)
		if (segmentId) query.set('segmentId', segmentId)
		const queryString = query.toString()

		fetch(
			`${BASE_URL}/api/myexperience/preview/${experienceId}${
				queryString ? `?${queryString}` : ''
			}`,
			{ signal: controller.signal },
		)
			.then(async (response) => {
				if (!response.ok) throw new Error('Experience preview lookup failed')
				return response.json()
			})
			.then(setData)
			.catch((error) => {
				if (error.name !== 'AbortError') setData(null)
			})

		return () => controller.abort()
	}, [enabled, experienceId, segmentId, stationId])

	const setPreviewOption = (key, value) => {
		const nextParams = new URLSearchParams(searchParams)
		if (value) nextParams.set(key, value)
		else nextParams.delete(key)
		setSearchParams(nextParams, { replace: true })
	}
	const previewOptions = data?.previewOptions || {}
	const hasStation = previewOptions.stations?.some(
		(option) => option.id === stationId,
	)
	const hasSegment = previewOptions.segments?.some(
		(option) => option.id === segmentId,
	)

	return {
		data,
		previewOptions,
		selectedStationId:
			enabled && hasStation
				? stationId
				: enabled
					? previewOptions.selectedStationId || null
					: null,
		selectedSegmentId:
			enabled && hasSegment
				? segmentId
				: enabled
					? previewOptions.selectedSegmentId || null
					: null,
		setStationId: (value) => setPreviewOption('stationId', value),
		setSegmentId: (value) => setPreviewOption('segmentId', value),
	}
}

export default useExperiencePreview
